import { render, staticRenderFns } from "./Tanto.vue?vue&type=template&id=25ca0954&scoped=true&lang=pug&"
import script from "./Tanto.vue?vue&type=script&lang=coffee&"
export * from "./Tanto.vue?vue&type=script&lang=coffee&"
import style0 from "./Tanto.vue?vue&type=style&index=0&id=25ca0954&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25ca0954",
  null
  
)

export default component.exports